var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectManagementSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.082 37.1667C32.082 41.2229 30.3174 44.8896 27.4987 47.3875C25.0695 49.5875 21.8612 50.9167 18.332 50.9167C10.7466 50.9167 4.58203 44.7521 4.58203 37.1667C4.58203 30.8417 8.89036 25.4792 14.7112 23.8979C16.2924 27.8854 19.6841 30.9563 23.8779 32.1021C25.0237 32.4229 26.2383 32.5833 27.4987 32.5833C28.7591 32.5833 29.9737 32.4229 31.1195 32.1021C31.7383 33.6604 32.082 35.3792 32.082 37.1667Z",
    fill: "url(#paint0_linear_1161_2161)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 18.8333C41.25 20.6208 40.9062 22.3396 40.2875 23.8979C38.7063 27.8854 35.3146 30.9563 31.1208 32.1021C29.975 32.4229 28.7604 32.5833 27.5 32.5833C26.2396 32.5833 25.025 32.4229 23.8792 32.1021C19.6854 30.9563 16.2938 27.8854 14.7125 23.8979C14.0938 22.3396 13.75 20.6208 13.75 18.8333C13.75 11.2479 19.9146 5.08334 27.5 5.08334C35.0854 5.08334 41.25 11.2479 41.25 18.8333Z",
    fill: "url(#paint1_linear_1161_2161)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.4167 37.1667C50.4167 44.7521 44.2521 50.9167 36.6667 50.9167C33.1375 50.9167 29.9292 49.5875 27.5 47.3875C30.3188 44.8896 32.0833 41.2229 32.0833 37.1667C32.0833 35.3792 31.7396 33.6604 31.1208 32.1021C35.3146 30.9563 38.7063 27.8854 40.2875 23.8979C46.1083 25.4792 50.4167 30.8417 50.4167 37.1667Z",
    fill: "url(#paint2_linear_1161_2161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1161_2161",
    x1: 4.58203,
    y1: 37.4073,
    x2: 32.082,
    y2: 37.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1161_2161",
    x1: 13.75,
    y1: 18.8333,
    x2: 41.25,
    y2: 18.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1161_2161",
    x1: 27.5,
    y1: 37.4073,
    x2: 50.4167,
    y2: 37.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#12D8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagementSystem);
export default __webpack_public_path__ + "static/media/projectManagementSystem.49ffcd0d6e9339a75f36981661ca5514.svg";
export { ForwardRef as ReactComponent };